import React from "react";
import { InboxOutlined } from "@ant-design/icons";
import { message, Upload, Flex } from "antd";
import { useSelector } from "react-redux";
import { baseURL } from "@/redux/api/fetchBaseQueryHelper";

const { Dragger } = Upload;

const UploadPickupReport = () => {
	const { token } = useSelector((state) => state.auth);

	const onChange = (info) => {
		if (info.file.status === "done") {
			message.success(`${info.file.name} file uploaded successfully`);
		} else if (info.file.status === "error") {
			message.error(`${info.file.name} file upload failed.`);
		}
	};

	const beforeUpload = (file) => {
		const isCSV = file.type === "text/csv";
		if (!isCSV) {
			message.error("You can only upload CSV file!");
		}

		const isPickupReport = file.name.toLowerCase().includes("pickupreport");
		if (!isPickupReport) {
			message.error("请检查是否上传了pickup csv!");
		}

		return isCSV && isPickupReport;
	};

	return (
		<Flex vertical gap="large">
			<Dragger
				name="file"
				beforeUpload={beforeUpload}
				accept=".csv"
				action={`${baseURL}/upload/pickupReport/csv`}
				headers={{ authorization: `Bearer ${token}` }}
				onChange={onChange}
			>
				<p className="ant-upload-drag-icon">
					<InboxOutlined />
				</p>
				<p className="ant-upload-text">
					Click or Drag file to this area to upload
				</p>
				<p className="ant-upload-hint">Pickup Report Only</p>
			</Dragger>
		</Flex>
	);
};
export default UploadPickupReport;
